import { Text } from '@/components/atoms/text';
import { Flex } from '@/styles/globalStyles';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { NoteBar } from '../../molecules/noteBar';
import { TitleContainer } from './styles';

interface ComparisonResultProps {
  title?: string;
  tooltip?: string;
  comparison: {
    note: number | string;
    color: string;
  };
  noTooltip?: boolean;
}

export const ComparisonResult = ({
  title,
  tooltip,
  comparison,
  noTooltip,
}: ComparisonResultProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Flex direction="column" gap={1} fullWidth>
      {title && (
        <TitleContainer>
          <Text variant="subtitle2" color="text.primary">
            {title}
          </Text>
        </TitleContainer>
      )}

      <NoteBar
        note={comparison.note}
        placement="right"
        isMobile={isMobile}
        color={comparison.color}
        height={16}
        tooltip={noTooltip ? undefined : tooltip}
      />
    </Flex>
  );
};
